
const digest = '3b2f5a2bd32e237f9f6b514d46dc139d22107ed218fdbe2ed5b95e18a1e57218';
const classes = {"wrapper":"_wrapper_1xpv7_1","patientPhoto":"_patientPhoto_1xpv7_10","base":"_base_1xpv7_18","notIdentified":"_notIdentified_1xpv7_18","lastVerification":"_lastVerification_1xpv7_18","verifyButton":"_verifyButton_1xpv7_18","addressValue":"_addressValue_1xpv7_18","insuranceValue":"_insuranceValue_1xpv7_18","phoneValue":"_phoneValue_1xpv7_18","emailValue":"_emailValue_1xpv7_18","addressTitle":"_addressTitle_1xpv7_18","insuranceTitle":"_insuranceTitle_1xpv7_18","genderTitle":"_genderTitle_1xpv7_18","age":"_age_1xpv7_18","birthNumber":"_birthNumber_1xpv7_18","patientName":"_patientName_1xpv7_18","item":"_item_1xpv7_54","pregnancyInfo":"_pregnancyInfo_1xpv7_60"};
const css = `._wrapper_1xpv7_1 {
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  padding: 12px 24px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

._patientPhoto_1xpv7_10 {
  width: 34px;
  height: 34px;
  background-position: center;
  background-size: cover;
  border-radius: 100%;
}

._base_1xpv7_18, ._notIdentified_1xpv7_18, ._lastVerification_1xpv7_18, ._verifyButton_1xpv7_18, ._addressValue_1xpv7_18, ._insuranceValue_1xpv7_18, ._phoneValue_1xpv7_18, ._emailValue_1xpv7_18, ._addressTitle_1xpv7_18, ._insuranceTitle_1xpv7_18, ._genderTitle_1xpv7_18, ._age_1xpv7_18, ._birthNumber_1xpv7_18, ._patientName_1xpv7_18 {
  font-size: 14px;
  font-family: Rubik, "sans-serif";
  font-weight: 400;
  color: #3e3f42;
}

._patientName_1xpv7_18 {
  font-weight: 500;
  text-decoration: underline;
}

._birthNumber_1xpv7_18 {
  min-width: max-content;
}

._addressValue_1xpv7_18, ._insuranceValue_1xpv7_18, ._phoneValue_1xpv7_18, ._emailValue_1xpv7_18 {
  font-weight: 500;
}

._verifyButton_1xpv7_18 {
  font-weight: 500;
  text-decoration: underline;
  color: #1665d8;
}

._lastVerification_1xpv7_18 {
  display: flex;
  gap: 5px;
}

._notIdentified_1xpv7_18 {
  font-weight: 500;
  color: #d81616;
}

._item_1xpv7_54 {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

._pregnancyInfo_1xpv7_60 {
  min-width: 280px;
  padding-left: 30px;
  margin-left: 10px;
}
._pregnancyInfo_1xpv7_60 ._item_1xpv7_54 {
  flex-wrap: wrap;
  gap: 0;
}
._pregnancyInfo_1xpv7_60 ._item_1xpv7_54 ._addressTitle_1xpv7_18 {
  margin-right: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  